import { IPagination } from '../states';
import { ISuggestionState } from '../states/suggestions';

export const initialSuggestionState: ISuggestionState = {
  value: [],
  isFetchingSuggestion: true,
  pagination: {} as IPagination,
};
